import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover'
import { FileText } from 'lucide-react'

interface FileCitationBadgeProps {
  index: number           // Citation number (1, 2, 3...)
  filename: string
  quote: string
}

export function FileCitationBadge({ index, filename, quote }: FileCitationBadgeProps) {
  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          aria-label={`Citation ${index}: ${filename || 'Document'}`}
          className="inline-flex items-center justify-center w-4 h-4 text-[10px]
                     font-medium rounded-full cursor-pointer align-super ml-0.5
                     focus:outline-none focus:ring-2
                     text-primary bg-primary/10 hover:bg-primary/20 focus:ring-primary/50"
        >
          {index}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-80 p-3">
        <div className="flex items-center gap-2 mb-2">
          <FileText className="h-4 w-4 text-muted-foreground" />
          <span className="font-medium text-sm">{filename || 'Document'}</span>
        </div>
        {quote ? (
          <p className="text-sm text-muted-foreground italic line-clamp-6">"{quote}"</p>
        ) : (
          <p className="text-sm text-muted-foreground italic">Referenced in response</p>
        )}
      </PopoverContent>
    </Popover>
  )
}
